import * as React from 'react'
import { Input, Label } from 'reactstrap'
import { getConfiguration } from '../../utils'

interface PreviewSettingsProps {
  data: any
  name?: string
  onChange: (field: string, value: any) => void
}

export class PreviewSettings extends React.Component<PreviewSettingsProps> {
  public render() {
    return (
      <div>
        <div className="widget-settings-section">
          <h4>Message Preview</h4>
          
          <div className="setting-item">
            <Label>Show Message Preview</Label>
            <Input
              type="select"
              value={getConfiguration(this.props.data, 'survey_results_show_message_preview', 'none')}
              onChange={(e) => this.props.onChange('survey_results_show_message_preview', e.target.value)}
            >
              <option value="none">No Message</option>
              <option value="success">Success Message</option>
              <option value="fail">Fail Message</option>
            </Input>
            <small className="form-text text-muted">
              Toggle between success and fail messages to see how they appear
            </small>
          </div>
        </div>

        <div className="widget-settings-section">
          <h4>Message Styling</h4>
          
          <div className="setting-item">
            <Label>Success Message Background</Label>
            <Input
              type="color"
              value={getConfiguration(this.props.data, 'survey_results_success_bg_color', '#d4edda')}
              onChange={(e) => this.props.onChange('survey_results_success_bg_color', e.target.value)}
            />
          </div>

          <div className="setting-item">
            <Label>Success Message Text Color</Label>
            <Input
              type="color"
              value={getConfiguration(this.props.data, 'survey_results_success_text_color', '#155724')}
              onChange={(e) => this.props.onChange('survey_results_success_text_color', e.target.value)}
            />
          </div>

          <div className="setting-item">
            <Label>Fail Message Background</Label>
            <Input
              type="color"
              value={getConfiguration(this.props.data, 'survey_results_fail_bg_color', '#f8d7da')}
              onChange={(e) => this.props.onChange('survey_results_fail_bg_color', e.target.value)}
            />
          </div>

          <div className="setting-item">
            <Label>Fail Message Text Color</Label>
            <Input
              type="color"
              value={getConfiguration(this.props.data, 'survey_results_fail_text_color', '#721c24')}
              onChange={(e) => this.props.onChange('survey_results_fail_text_color', e.target.value)}
            />
          </div>
        </div>
      </div>
    )
  }
}